import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from '@govard/i18n-core/react';
import { message } from 'antd';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import { postTelegramGroupAgentTurn } from '../api/telegram-group-agent.client.js';

export const telegramCandidatesKeys = {
  list: (workspaceId: string) => ['telegram-candidates', workspaceId] as const,
};

export function useTelegramGroupAgentTurn() {
  const scope = useCurrentScope();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({
      candidateId,
      expectedStateVersion,
      locale,
    }: {
      candidateId: string;
      expectedStateVersion: number;
      locale?: 'ru' | 'en';
    }) => {
      if (locale === undefined) {
        return postTelegramGroupAgentTurn(candidateId, { expectedStateVersion });
      }
      return postTelegramGroupAgentTurn(candidateId, { expectedStateVersion, locale });
    },
    onSuccess: async () => {
      const workspaceId = scope?.workspaceId;
      if (workspaceId !== undefined) {
        await queryClient.invalidateQueries({ queryKey: telegramCandidatesKeys.list(workspaceId) });
      } else {
        await queryClient.invalidateQueries({ queryKey: ['telegram-candidates'] });
      }
      message.success(t('crm.telegram_candidates.agent_turn.success.enriched' as never));
    },
    onError: () => {
      message.error(t('crm.telegram_candidates.agent_turn.error.enrich_failed' as never));
    },
  });
}
